import { useRef, useEffect, useState } from "react"
import Layout from '../../Layout'
import RightSidebar from "components/Checkout/RightSidebar"
import ShippingInfo from "components/Checkout/ShippingInfo"
import CheckoutProductList from "components/Checkout/CheckoutProductList"
import DeliveryMethod from "components/Checkout/DeliveryMethod"
import PaymentMethod from "components/Checkout/PaymentMethod"
import OrderNote from "components/Checkout/OrderNote"
import { useLocation } from "react-router-dom"

export default function Checkout() {
    const location = useLocation();
    const { selectedItems = [], selectedVouchers = [] } = location.state || {}; // Default to empty arrays

    // Lifted state
    const [fullname, setFullname] = useState("Nhà thuốc Vũ Huy");
    const [phone, setPhone] = useState("0932115595");
    const [address, setAddress] = useState("27 Nguyễn Hữu Trí, ấp 57, Xã Tân Nhựt, Huyện Bình Chánh, Thành phố Hồ Chí Minh");
    const [paymentMethod, setPaymentMethod] = useState("PAYMENT_METHOD_BANK");
    const [note, setNote] = useState("");


    useEffect(() => {
        document.body.classList.add("NoneFooter");

        return () => {
            document.body.classList.remove("NoneFooter");
        };
    }, []);
    return (
        <Layout>
            <div className="MuiContainer-root MuiContainer-disableGutters MuiContainer-maxWidthLg mobile-mt-24 ">
                <div className="styles_wrapper_gray__f8P4_">
                    <div className="styles_payment_wrapper__R7Bz9">
                        <div className="MuiGrid-root styles_payment_grid__kN77N MuiGrid-container">
                            <div className="MuiGrid-root styles_itemLeft__fZHT_ MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-9">
                                <div id="delivery__info_form" className="styles_wMax__iGEzJ">
                                    <ShippingInfo 
                                        fullname={fullname}
                                        phone={phone}
                                        address={address}
                                        onUpdateInfo={(name, ph, addr) => {
                                            setFullname(name);
                                            setPhone(ph);
                                            setAddress(addr);
                                        }}
                                    />
                                </div>
                                <CheckoutProductList selectedItems={selectedItems} />
                                {/* <DeliveryMethod /> */}
                                <PaymentMethod paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod} />
                                <OrderNote note={note} setNote={setNote} />
                            </div>
                            <RightSidebar 
                                selectedItems={selectedItems} 
                                selectedVouchers={selectedVouchers}
                                fullname={fullname}
                                phone={phone}
                                address={address}
                                paymentMethod={paymentMethod}
                                note={note}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
